// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_r06","badges":"styles_badges__qB3AS"};